import { QuizAttemptHint } from "@/components/storyboard/quiz/QuizAttemptHint";
import { GradedFeedback } from "@/components/storyboard/GradedFeedback";
import type { ValidationResult } from "@/services/QuizValidationService";

interface CodeQuizVerdictProps {
  /** The last verdict for the task on screen; nothing renders without one. */
  result?: ValidationResult;
  /** Retry copy, phrased for what the learner hands in (code, explanation …). */
  retryDescription: string;
}

/**
 * The graded verdict of one code-quiz task, with the attempt budget above it —
 * the learner should know whether another go is coming before reading what
 * went wrong. The banner stays away on a correct answer and on the uncapped
 * types, which report no budget.
 */
export const CodeQuizVerdict = ({
  result,
  retryDescription,
}: CodeQuizVerdictProps) => {
  if (!result) return null;

  return (
    <div className="flex flex-col gap-3">
      {result.correct !== true && (
        <QuizAttemptHint
          attemptCount={result.attemptCount}
          maxAttempts={result.maxAttempts}
          description={retryDescription}
        />
      )}
      <GradedFeedback result={result} />
    </div>
  );
};

/**
 * The review band only when a verdict exists. An empty element would still
 * reserve the workspace slot above the exercise.
 */
export const codeQuizReview = (
  result: ValidationResult | undefined,
  retryDescription: string
) => {
  if (!result) return undefined;

  return (
    <CodeQuizVerdict result={result} retryDescription={retryDescription} />
  );
};

export default CodeQuizVerdict;
